import { defineStore } from 'pinia';

// FBKS-2718: comments of the cart being displayed, newest first
export const useCartCommentStore = defineStore('CartCommentStore', {
  state: () => ({
    comments: [],
    error: null
  }),
  getters: {
    count: (state) => state.comments.filter(comment => !comment.deleted_by).length,
    unreadCount: (state) => state.comments.filter(comment => comment.unread).length
  },
  actions: {
    async request(method, path, data) {
      this.error = null;
      try {
        return (await this.$axios[method](path, data)).data.data;
      } catch (error) {
        this.error = error.response?.data?.error || error.message;
        return null;
      }
    },
    async fetchComments(cartId) {
      this.comments = (await this.request('get', `/carts/${cartId}/comments`)) || [];
    },
    async markAsRead(cartId) {
      await this.request('post', `/carts/${cartId}/comments/read`);
    },
    async createComment(cartId, body) {
      const comment = await this.request('post', `/carts/${cartId}/comments`, { comment: { body } });
      if (comment) this.comments.unshift(comment);
      return comment;
    },
    async updateComment(cartId, id, body) {
      return this.replace(await this.request('patch', `/carts/${cartId}/comments/${id}`, { comment: { body } }));
    },
    async deleteComment(cartId, id) {
      return this.replace(await this.request('delete', `/carts/${cartId}/comments/${id}`));
    },
    replace(comment) {
      if (comment) this.comments.splice(this.comments.findIndex(item => item.id === comment.id), 1, comment);
      return comment;
    }
  }
});
